import { render, staticRenderFns } from "./NotifyComponent.vue?vue&type=template&id=60c076c4&"
import script from "./NotifyComponent.vue?vue&type=script&lang=js&"
export * from "./NotifyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports